'use client';

import React from 'react';

import { GrowthbookFlag } from 'common/constants/feature-flags';
import { useFeatureFlagValue } from 'common/hooks/feature-flags';

const GrowthBookAATests = () => {
  const crossDeviceByCustomerId = useFeatureFlagValue(
    GrowthbookFlag.CrossDeviceAATestByCustomerId,
    'none'
  );

  const crossDeviceExperienceV2 = useFeatureFlagValue(
    GrowthbookFlag.CrossDeviceAATestByExperienceV2,
    'none'
  );

  const crossDeviceByDeviceHash = useFeatureFlagValue(
    GrowthbookFlag.CrossDeviceAATestByDeviceHash,
    'none'
  );
  const crossDeviceByExperienceVariant = useFeatureFlagValue(
    GrowthbookFlag.CrossDeviceAATestByExperienceVariant,
    'none'
  );
  const crossDeviceByunum = useFeatureFlagValue(GrowthbookFlag.CrossDeviceAATestByUnum, 'none');
  const crossDeviceByIp = useFeatureFlagValue(GrowthbookFlag.CrossDeviceAATestByIp, 'none');
  const crossDeviceByRandom = useFeatureFlagValue(GrowthbookFlag.CrossDeviceAATestByRandom, 'none');
  const crossDevicePerBotType = useFeatureFlagValue(
    GrowthbookFlag.CrossDeviceAATestPerBotType,
    'none'
  );

  return (
    <div
      style={{ display: 'none' }}
      id="cross-device-aa-test"
      data-cross-device-by-customer-id={crossDeviceByCustomerId}
      data-cross-device-by-device-hash={crossDeviceByDeviceHash}
      data-cross-device-by-experience-variant={crossDeviceByExperienceVariant}
      data-cross-device-by-gtm-unum={crossDeviceByunum}
      data-cross-device-by-ip={crossDeviceByIp}
      data-cross-device-by-random={crossDeviceByRandom}
      data-cross-device-per-bot-type={crossDevicePerBotType}
      data-cross-device-experience-v2={crossDeviceExperienceV2}
    ></div>
  );
};

export default GrowthBookAATests;
